import { render, staticRenderFns } from "./AddAssistance.vue?vue&type=template&id=4501d9c8&scoped=true&"
import script from "./AddAssistance.vue?vue&type=script&lang=js&"
export * from "./AddAssistance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4501d9c8",
  null
  
)

export default component.exports